import { render, staticRenderFns } from "./kilometers.vue?vue&type=template&id=5b2ecf16"
import script from "./kilometers.vue?vue&type=script&lang=js"
export * from "./kilometers.vue?vue&type=script&lang=js"
import style0 from "./kilometers.vue?vue&type=style&index=0&id=5b2ecf16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports